import React from 'react';

function Footer() {
  return(
    <div className='footer'>
      <span>©2018 Chris Crow</span><br />
      <a href='mailto:chrismcrow@gmail.com' target='_blank' rel="noopener noreferrer">ChrisMCrow@gmail.com</a> | <a href='https://www.linkedin.com/in/chrismcrow/' target='_blank' rel="noopener noreferrer">LinkedIn</a> | <a href='https://www.github.com/ChrisMCrow' target='_blank' rel="noopener noreferrer">GitHub</a>
    </div>
  )
}

export default Footer;
